import { useState, useEffect, useContext, useMemo } from 'react'
import { HeadingTitle} from '../../../components/modules/ui/index'
// import { ExportCSV, ExportXLS } from '../../../components/modules/table/ExportData'
// import ExportPDF from '../../../components/modules/table/typesExportPDF/ExportPDFEstadoResultado'
import Table from './Table'
import GlobalContext from '../../../context/global-context'
import { BusinessAPI } from '../../../api/business.api'
import dayjs from 'dayjs'
import FilterDateControl from '../../../components/modules/table/FilterDateControl'
import ExportToXlsxModal from '../../../components/modules/modals/ExportToXlsxModal'

const ListEstadoDeResultados = () => {
  const { ui, currentBusiness } = useContext(GlobalContext)
  const businessAPI = useMemo(() => new BusinessAPI(), [])
  const [data, setData] = useState([])
  const [filters] = useState({
      fechaInicio: dayjs().startOf('month').format('YYYY-MM-DD'),
      fechaFin: dayjs().format('YYYY-MM-DD'),
    })
    const [tempFilters] = useState({ ...filters })
  const [isExportModalOpen, setIsExportModalOpen] = useState(false)
  const [isExporting, setIsExporting] = useState(false)

  /*const monthsOptions = months.map(monthOption => ({
    ...monthOption,
    disabled: yearFilter == currentYear && monthOption.value > currentMonth
  }))*/

  const getData = async () => {
    if (currentBusiness?.id) {
      ui.setLoader({ visible: true, text: 'Cargando los datos de la tabla...' })
      await businessAPI
        .getEstadoResultado({
          businessId: currentBusiness.id,
          from: tempFilters.fechaInicio,
          to: tempFilters.fechaFin
        })
        .then(({ data }) => {
          setData(data)
        })
        .catch(error => {
          setData([])
          console.error(error)
        })
        .finally(() => {
          ui.setLoader({ visible: false, text: '' })
        })
    } else {
      console.error('No dato')
    }
  }

  useEffect(() => {
    getData()
  }, [currentBusiness])
    
  /*const handleMonthYearChange = (e) => {
    const [year, month] = e.target.value.split('-');
    setMonthFilter(month);
    setYearFilter(year);
  }*/

    // const dataToExport = data.map(item => ({
    //   codeCuenta: item.codeCuenta,
    //   nameCuenta: item.nameCuenta,
    //   saldoMes: Number(item.saldoPeriodo ?? 0),     // Forzamos a número
    //   saldoAcumulado: Number(item.saldoAcumulado ?? 0),
    // }))
    
  const handleExport = async (email) => {
    if (!currentBusiness?.id) return
    setIsExporting(true)
    try {
      await businessAPI.exportEstadoResultado({
        businessId: currentBusiness.id,
        email,
        from: tempFilters.fechaInicio,
        to: tempFilters.fechaFin,
      })
    } catch (error) {
      console.error('Error al exportar estado de resultados:', error)
      throw error
    } finally {
      setIsExporting(false)
    }
  }

  const icons = [
    <button
      key='export-xlsx'
      className='w-10 h-10 text-green-700 font-bold cursor-pointer rounded-full shadow bg-white'
      onClick={() => setIsExportModalOpen(true)}
      disabled={!currentBusiness?.id}
    >
      XLS
    </button>
  ]

  return (
    <>
       <HeadingTitle title='Estado de Resultados' rightIcons={icons} iconHeight={32}/>
        <div className='p-4'>
          <div className='grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 items-end'>
            <FilterDateControl
              label='Fecha Desde'
              value={tempFilters.fechaInicio}
              disabled
            />
            <FilterDateControl
              label='Fecha Hasta'
              value={tempFilters.fechaFin}
              disabled
            />
          </div>
        </div>
        <Table 
          rows={data}
          getData={getData}
        />
        <ExportToXlsxModal
          isOpen={isExportModalOpen}
          onClose={() => setIsExportModalOpen(false)}
          onExport={handleExport}
          title='Exportar Estado de Resultados'
          description='Se enviará un archivo Excel con el estado de resultados al email especificado'
          isLoading={isExporting}
        />
    </>
  )
}

export default ListEstadoDeResultados
